module.exports = __webpack_public_path__ + "img/1-full-md.b04da392.jpg";